<template>
  <div class="programme">
    <div class="banner">
      <img class="bg"
           src="https://lambor.oss-cn-shenzhen.aliyuncs.com/banner1.png" />
      <img class="bg bg_end"
           src="https://lambor.oss-cn-shenzhen.aliyuncs.com/banner_programme_end.png" />
      <div class="w">
        <h1>贴身打造的产融数字化解决方案</h1>
      </div>
    </div>
    <div class="m_banner">
      <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/4AB40C35B18D62D9.png"
           alt="" />
    </div>
    <div class="main">
      <div class="w">
        <div class="list"
             id="backgroundPic">
          <div class="listBx">
            <div class="item">
              <div class="imgTitle">
                智慧风控解决方案
              </div>
              <div class="imgBx">
                <img src="../assets/img/programme/main1.png"
                     alt="">
              </div>
            </div>
            <div class="item">
              <div class="imgTitle">
                资金方风险决策解决方案
              </div>
              <div class="imgBx">
                <img src="../assets/img/programme/main2.png"
                     alt="">
              </div>
            </div>
            <div class="item">
              <div class="imgTitle">
                供应链金融解决方案
              </div>
              <div class="imgBx">
                <img src="../assets/img/programme/main3.png"
                     alt="">
              </div>
            </div>
            <div class="item">
              <div class="imgTitle">
                数据中台解决方案
              </div>
              <div class="imgBx">
                <img src="../assets/img/programme/main4.png"
                     alt="">
              </div>
            </div>
            <div class="item">
              <div class="imgTitle">
                国企供应链服务解决方案
              </div>
              <div class="imgBx">
                <img src="../assets/img/programme/main5.png"
                     alt="">
              </div>
            </div>
            <div class="item">
              <div class="imgTitle">
                产融平台战略架构方案
              </div>
              <div class="imgBx">
                <img src="../assets/img/programme/main6.png"
                     alt="">
              </div>
            </div>
          </div>
        </div>

        <div class="m_listBx">
          <div class="m_listBx_header">
            <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/16F431C0EC57111F.png"
                 alt="">
          </div>

          <div class="item cildren_item"
               style="margin-top: 90px;">
            <div class="image-border image-border1"></div>
            <div class="image-border image-border2"></div>
            <div class="image-border image-border3"></div>
            <div class="image-border image-border4"></div>
            <h5>
              智慧风控解决方案
            </h5>
            <div class="imgBx">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/C9B42BF9EBC94491.png"
                   alt="">
            </div>
          </div>

          <div class="item cildren_item">
            <div class="image-border image-border1"></div>
            <div class="image-border image-border2"></div>
            <div class="image-border image-border3"></div>
            <div class="image-border image-border4"></div>
            <h5>
              数据中台解决方案
            </h5>
            <div class="imgBx">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/A20498465D24B9E5.png"
                   alt="">
            </div>
          </div>

          <div class="item cildren_item">
            <div class="image-border image-border1"></div>
            <div class="image-border image-border2"></div>
            <div class="image-border image-border3"></div>
            <div class="image-border image-border4"></div>
            <h5>
              资产方风险决策解决方案
            </h5>
            <div class="imgBx">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/24C490D5AC1F25F7.png"
                   alt="">
            </div>
          </div>

          <div class="item cildren_item">
            <div class="image-border image-border1"></div>
            <div class="image-border image-border2"></div>
            <div class="image-border image-border3"></div>
            <div class="image-border image-border4"></div>
            <h5>
              国企供应链服务解决方案
            </h5>
            <div class="imgBx">
              <img src="https://lambor.oss-cn-shenzhen.aliyuncs.com/4ED4D4B82FFE9ADA.png"
                   alt="">
            </div>
          </div>
          <h6>
            更多解决方案…
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'programme'
}
</script>

<style lang="scss" scoped>
#backgroundPic {
  background: url("https://lambor.oss-cn-shenzhen.aliyuncs.com/layout.png")
    no-repeat;
  background-position-y: bottom;
}
.programme {
  background: #160f00;
  overflow: hidden;
}
.banner {
  width: 100%;
  display: block;
  overflow: hidden;
}

.banner,
.banner .bg,
.w {
  position: relative;
}

.banner .bg {
  width: 100%;
  min-height: 312px;
  float: left;
}

.banner h1 {
  font-size: 60px;
  color: #fff;
  font-weight: 600;
  position: absolute;
  top: 164px;
  white-space: nowrap;
  width: 100%;
  text-align: center;
}

.banner img:first-child {
  min-height: 514px;
}

.banner .bg_end {
  z-index: 10;
  position: absolute;
  bottom: 0;
  left: 0;
}

.banner .bg_title {
  padding-top: 175px;
  width: 100%;
  position: relative;
  bottom: 220px;
  left: 0;
}

.main {
  background: #160f00;
  height: 100%;
  padding-bottom: 64px;
  position: relative;
}

.main .w .list {
  margin-top: 50px;
  height: 868px;
  background-position-y: bottom;
}

.main .w .list .listBx {
  padding-top: 216px;
  padding-left: 75px;
  overflow: hidden;
}

.main .w .list .listBx .item {
  float: left;
  margin-right: 26px;
}

.main .w .list .listBx .item .imgTitle {
  position: relative;
  height: 20px;
  font-size: 20px;
  font-weight: 700;
  color: #e7bf82;
  line-height: 48px;
  text-align: center;
}

.main .w .list .listBx .item .imgTitle:before {
  position: absolute;
  content: "";
  width: 30px;
  height: 30px;
  background: url(data:image/png;base64,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)
    no-repeat;
  top: 10px;
}

.main .w .list .listBx .item .imgBx {
  width: 319px;
  height: 212px;
  background: #fff;
  margin-top: 30px;
  overflow: hidden;
}

.main .w .list .listBx .item .imgBx img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
}

.main .w .list .listBx .item:nth-child(4) .imgBx img {
  transform: scale(1.1);
}

.main .w .list .listBx .item:first-child .imgTitle::before,
.main .w .list .listBx .item:nth-child(4) .imgTitle:before {
  left: 40px;
}

.main .w .list .listBx .item:nth-child(2) .imgTitle:before,
.main .w .list .listBx .item:nth-child(5) .imgTitle:before {
  left: 12px;
}

.main .w .list .listBx .item:nth-child(6) .imgTitle:before {
  left: 21px;
}

.main .w .list .listBx .item:nth-child(3) .imgTitle:before {
  left: 30px;
}

.m_banner,
.m_listBx,
.main .w .list .m_listBx {
  display: none;
}

@media screen and (min-width: 1170px) {
  .main > .w {
    width: 1170px;
    margin: auto;
  }
}

@media screen and (max-width: 1170px) {
  .banner {
    display: none;
  }

  .m_banner {
    display: block;
    width: 100%;
  }

  .m_banner img {
    width: 100%;
    height: 100%;
  }

  .m_listBx {
    display: block;
  }

  .main {
    margin-top: 20px;
  }

  .main .w .list {
    display: none;
  }

  .m_listBx_header {
    width: auto;
    height: 36px;
    line-height: 36px;
    margin: auto;
    text-align: center;
  }

  .m_listBx_header img {
    height: 100%;
  }

  .main .w .m_listBx .cildren_item {
    text-align: center;
  }

  .main .w .m_listBx .cildren_item h5 {
    position: relative;
    font-size: 1.625rem;
    font-weight: 600;
    font-weight: 700;
    color: #d0b26c;
    top: -5.5rem;
    background: linear-gradient(0deg, #af8f54, #fae5a4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .main .w .m_listBx .cildren_item h5:before {
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    top: 5px;
    margin-left: -52px;
    background: url(data:image/png;base64,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)
      no-repeat;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/programme.vue